import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const attributeKey = z.string().nullish();

const additionalAttributeKeys = z.object({
  additionalAttributeKey1: attributeKey,
  additionalAttributeKey2: attributeKey,
  additionalAttributeKey3: attributeKey,
  additionalAttributeKey4: attributeKey,
  additionalAttributeKey5: attributeKey,
  additionalAttributeKey6: attributeKey,
  additionalAttributeKey7: attributeKey,
  additionalAttributeKey8: attributeKey,
  additionalAttributeKey9: attributeKey,
  additionalAttributeKey10: attributeKey,
});

export const cin7CoreSettings = defineIntegrationSettings({
  fields: {
    accountId: z.string().trim().min(1, "Account ID is required"),
    wmsEnabled: z.boolean(),
    omsEnabled: z.boolean(),
    locationName: z.string().trim().min(1).nullable(),
    skuMappings: z.array(
      z.object({
        sku: z.string().trim().min(1),
        values: z.array(z.string().trim().min(1)),
      }),
    ),
    salesChannelLocations: z.array(
      z.object({
        locationName: z.string().trim().min(1),
        salesChannelsToInclude: z.array(z.string()),
      }),
    ),
    saleAttributes: additionalAttributeKeys,
    productAttributes: additionalAttributeKeys,
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
